// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'

export default function AlertsSection() {
  const { t } = useTranslation('solutionsIotAirQualityMonitoring')

  const items = [
    t('alerts.items.01'),
    t('alerts.items.02'),
    t('alerts.items.03'),
    t('alerts.items.04'),
    t('alerts.items.05'),
    t('alerts.items.06')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('alerts.eyebrow')}
        title={t('alerts.title')}
        intro={[t('alerts.intro1'), t('alerts.intro2'), t('alerts.intro3')]}
      />

      <BulletGrid items={items} columns={2} />
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.section.light}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
